export default function creditRequestConfig($stateProvider) {
  'ngInject';
  $stateProvider.state('webPublicClient.creditRequest', {
    url: '/credit-request',
    template: '<credit-request></credit-request>'
  });
};



// WEBPACK FOOTER //
// ./src/credit-request/credit-request.config.js